import { render } from "./EventSave.vue?vue&type=template&id=2ff7582c"
import script from "./EventSave.vue?vue&type=script&lang=js"
export * from "./EventSave.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__